<template>
    <div class="container_product_list_widget">
        <section
            :class="['product_list_widget product_seccion_widget', sectionActive === i.id ? 'active' : '']"
            v-for="(i, idx) in listMain" :key="idx"
            :id="'section-'+i.id"
            :data-row="i.id"
        >
            <article
                v-for="(product, index) in i.products" :key="index"
                v-if="product.visibility_status !== 'hidden'"
                class="product_item_container_widget"
            >
                <div class="product_item_widget">
                    <header class="product_item_header_widget ">
                        <h4 class="product_item_name_widget with_logo">
                            <span class="logo_perfil">
                                <i class="fas fa-info-circle"></i>
                            </span>
                            {{ product.product_name }}
                        </h4>
                    </header>
                    <product-slider-widget
                        :indicador="product.id"
                        :productItem="product"
                        :gallery="product.gallery"
                        :urlMedia="urlMedia"
                        @clickNav="goToSlide($event)"
                    ></product-slider-widget>
                    <aside>
                        <div
                            :class="[
                                'product_item_price', product.discount_active ? 'discount_active' : '',
                                product.sell_status ? 'sell_status-' + product.sell_status : '',
                                product.price_type ? 'price_type-' + product.price_type : ''
                                ]"
                            :data-indicador="product.id"
                        >
                            <div :class="['price_product', (product.price_type=='contact' || product.sell_status=='showcase') ? 'edit_price_contact' : '']">
                                <div v-if="product.price_type!='contact' && product.sell_status!='showcase'" class="price_type_display">
                                    <span v-if="product.price_type=='variable'" >From: </span>
                                    <div v-if="product.discount_active && product.discount_percent > 0" class="product_item_price_discount">
                                        {{currency}} {{ precio_final(product) | formatMoney}}
                                    </div>
                                    <div v-else class="normal">
                                        {{currency}} {{ precio_final(product) | formatMoney}}
                                    </div>
                                    <div v-if="product.discount_active && product.discount_percent > 0" :class="[product.discount_active ? 'with_discount' : '']">
                                        <span class="line-through">{{currency}} {{ product.price | formatMoney}}</span>
                                        <span class="offer_special" v-if="product.discount_percent > 0"> You save {{ product.discount_percent }}%</span>
                                    </div>
                                </div>
                                <div v-else class="price_type_display">
                                    <i class="fa fa-pen"></i> Price
                                </div>
                            </div>
                            <div class="input_quantity" v-if="product.allow_quantity && product.price_type!='contact' && product.sell_status=='available'">
                                <div class="form-group">
                                    <div class="input-group">
                                        <span class="input-group-text" style="padding:0;">
                                            <button class="btn_quantity" @click.prevent="() => { return false;}">-</button>
                                        </span>
                                        <input type="text" class="form-control quantity" value="1" readonly min="1" v-model="qty">
                                        <span class="input-group-text" style="padding:0;">
                                            <button class="btn_quantity" @click.prevent="() => { return false;}">+</button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </aside>
                    <footer>
                        <div v-html="product.product_desc" :data-indicador="product.id" @click.prevent="activeDescrip(product)" :class="['product_item_details', { full: showDescrip_id === product.id }]"></div>
                        <div class="content_btn_add_to_cart" :data-indicador="product.id">
                            <div class="buttons_shop_contact">
                                <button v-if="product.price_type == 'fixed' && product.sell_status == 'available'" :class="['btn_add_to_cart', !show_btn_ws ? 'full_width' : '']"
                                    @click="() => { return false; }">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <circle cx="9" cy="21" r="1"></circle>
                                        <circle cx="20" cy="21" r="1"></circle>
                                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                                    </svg>
                                    Add to cart
                                </button>
                                <button
                                    v-else-if="product.price_type == 'contact' || product.price_type == 'variable' || product.sell_status != 'available'"
                                    :class="['btn_contact', !show_btn_ws ? 'full_width' : '']" @click="() => { return false; }">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <line x1="22" y1="2" x2="11" y2="13"></line>
                                        <polygon points="22 2 15 22 11 13 2 9"></polygon>
                                    </svg>
                                    {{ contact_btn_text }}
                                </button>
                                <button class="btn-bStore_ws" v-if="show_btn_ws" @click="() => { return false; }">
                                    <i class="fab fa-whatsapp"></i>
                                </button>
                            </div>
                        </div>
                    </footer>
                </div>
            </article>
        </section>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import productSlider_widget from "./productSlider.vue"
export default {
    props: ['urlMedia', 'listCat', 'menuCatActivo', 'getCurrency', 'sectionActive'],
    components: {
        'product-slider-widget': productSlider_widget,
    },
    data(){
        return {
            listMain: [],
            qty: 1,
            apis: null,
            showDescrip_id: null,
            contact_btn_text: 'Contact',
            show_btn_ws: false,
        };
    },
    created(){
        let t = this;
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bStore;
        this.listMain = this.listCat;
    },
    watch: {
        listCat(newVal){
            this.listMain = newVal;
            this.$nextTick(() => { this.startSlider(); });
        },
        sectionActive(){
            this.$nextTick(() => { this.startSlider(); });
        },
        get_info: {
            handler(newVal){
                let t = this;
                // console.log('get_info', newVal);
                t.contact_btn_text = (newVal && newVal.contact_btn_text) ? newVal.contact_btn_text : 'Contact';
                t.show_btn_ws = !!(newVal && Number(newVal.show_btn_ws) > 0);
            },
            deep: true,
            immediate: true,
        },
    },
    mounted(){
        this.get_currency();
        this.get_bStoreInfo();
        this.$nextTick(() => { this.startSlider(); });
    },
    methods: {
        activeDescrip(product){
            if(this.showDescrip_id === product.id){
                this.showDescrip_id = null;
            } else {
                this.showDescrip_id = product.id;
            }
        },
        calcDiscount(price, discount){
            return (parseFloat(price) - (parseFloat(price) * (parseFloat(discount) / 100))).toFixed(2);
        },
        startSlider(){
            const sliders = document.querySelectorAll('.container_bStore_widget .product_gallery_slider_widget');
            if(!sliders.length) return;
            sliders.forEach(slider => this.sliderEvent(slider));
        },
        sliderEvent(slider){
            if(!slider || slider._sliderInit) return;
            slider._sliderInit = true;
            const sliderId = slider.dataset.slider;
            const slides = slider.querySelectorAll('ul li');
            const navItems = document.querySelectorAll(
                `#product_item_content_media_widget_${sliderId} a[class^="nav-item"]`
            ) || [];
            let isDragging = false;
            let startX = 0;
            let scrollStart = 0;
            let activeIndex = 0;
            let ticking = false;
            slider.style.maxHeight = 'min(520px, 80vh)';
            slider.style.cursor = 'grab';
            const onPointerDown = (e) => {
                isDragging = true;
                slider.setPointerCapture(e.pointerId);
                startX = e.clientX;
                scrollStart = slider.scrollLeft;
                slider.classList.add('dragging');
                slider.style.userSelect = 'none';
            };
            const onPointerMove = (e) => {
                if(!isDragging) return;
                const dx = e.clientX - startX;
                slider.scrollLeft = scrollStart - dx * 1.2;
            };
            const onPointerUp = (e) => {
                isDragging = false;
                try { slider.releasePointerCapture(e.pointerId); } catch(err) {}
                slider.classList.remove('dragging');
                slider.style.userSelect = '';
            };
            slider.addEventListener('pointerdown', onPointerDown);
            slider.addEventListener('pointermove', onPointerMove);
            slider.addEventListener('pointerup', onPointerUp);
            slider.addEventListener('pointerleave', onPointerUp);
            const updateActiveSlide = () => {
                const sliderRect = slider.getBoundingClientRect();
                let closest = null;
                let closestOffset = Infinity;
                slides.forEach((slide, index) => {
                    const rect = slide.getBoundingClientRect();
                    const offset = Math.abs(rect.left - sliderRect.left);
                    if(offset < closestOffset){
                        closestOffset = offset;
                        closest = slide;
                        activeIndex = index;
                    }
                });
                slides.forEach(s => s.classList.remove('active'));
                navItems.forEach(n => n.classList.remove('active'));
                if(closest){
                    closest.classList.add('active');
                    if(navItems[activeIndex]) navItems[activeIndex].classList.add('active');
                }
                detectRatio();
            };
            slider.addEventListener('scroll', () => {
                if(!ticking){
                    window.requestAnimationFrame(() => {
                        updateActiveSlide();
                        ticking = false;
                    });
                    ticking = true;
                }
            });
            function detectRatio(){
                const activeSlide = slider.querySelector('li.active') || slider.querySelector('li');
                if(!activeSlide) return;
                const media = activeSlide.querySelector('img, video');
                if(!media) return;
                const applyRatio = (width, height) => {
                    const ratio = width / height;
                    const safeRatio = Math.min(Math.max(ratio, 0.6), 1.8);
                    slider.style.aspectRatio = safeRatio;
                    slider.style.maxHeight = 'min(520px, 80vh)';
                    slider.classList.remove('ratio-vertical', 'ratio-horizontal', 'ratio-square');
                    if(safeRatio <= 0.9) slider.classList.add('ratio-vertical');
                    else if(safeRatio >= 1.3) slider.classList.add('ratio-horizontal');
                    else slider.classList.add('ratio-square');
                };
                const handleImage = () => applyRatio(media.naturalWidth, media.naturalHeight);
                const handleVideo = () => applyRatio(media.videoWidth, media.videoHeight);
                if(media.tagName === 'IMG'){
                    if(media.complete && media.naturalWidth && media.naturalHeight){ handleImage(); }
                    else { media.addEventListener('load', handleImage, {once: true}); }
                } else if(media.tagName === 'VIDEO'){
                    if(media.readyState >= 1 && media.videoWidth && media.videoHeight){ handleVideo(); }
                    else { media.addEventListener('loadedmetadata', handleVideo, {once: true}); }
                }
            }
            detectRatio();
            window.addEventListener('resize', detectRatio);
            updateActiveSlide();
        },
        get_currency(){
            let t = this;
            t.$store.commit("core/setLoadingModal", true);
            let formData = {};
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = (typeof pusher !== 'undefined' && pusher && pusher.connection)? pusher.connection.socket_id : null;
            let urlService = t.apis.get(4)// get_currency
            window.master.post(urlService, formData)
            .then((response) => {
                console.log(urlService, response.data);
                if (response.data.status && response.data.currency && response.data.currency.meta_value) {
                    t.$store.commit('ModApps/Marketea/set_bStore_currency', response.data.currency.meta_value);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        get_bStoreInfo(){
            let t = this;
            let formData = {};
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = (typeof pusher !== 'undefined' && pusher && pusher.connection)? pusher.connection.socket_id : null;
            let urlService = t.apis.get(2)// getInfo
            window.master.post(urlService, formData)
            .then((response) => {
                console.log(urlService, response.data);
                if (response.data.status && response.data.info) {
                    t.$store.commit('ModApps/Marketea/set_bStore_info', response.data.info);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        precio_final: function(product) {
            if(product.discount_active && product.discount_percent > 0){
                return (product.price - ((product.discount_percent * product.price) / 100));
            }
            return product.price;
        }
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            currency: "get_bStore_currency",
            get_info: "get_bStore_info",
        }),
    }
}
</script>
<style lang="scss" scoped></style>
